import * as React from "react";
const SvgFiRrCapsules = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-capsules_svg__a)">
      <path
        fill="#062147"
        d="M23.204 14.384 17.877 4.375a6.51 6.51 0 0 0-7.531-3.112A6.46 6.46 0 0 0 6.5 0 6.51 6.51 0 0 0 0 6.5v11C0 21.084 2.916 24 6.5 24a6.5 6.5 0 0 0 5.499-3.038 6.46 6.46 0 0 0 3.681 2.777 6.467 6.467 0 0 0 4.946-.541 6.46 6.46 0 0 0 3.115-3.879 6.45 6.45 0 0 0-.535-4.935zm-7.087-9.058 2.273 4.27L13 12.552V6.499a6.46 6.46 0 0 0-1.022-3.496 4.5 4.5 0 0 1 4.14 2.322zM6.5 2C8.981 2 11 4.019 11 6.5V11H2V6.5C2 4.019 4.019 2 6.5 2m0 20A4.505 4.505 0 0 1 2 17.5V13h9v4.5c0 2.481-2.019 4.5-4.5 4.5m15.319-3.241a4.47 4.47 0 0 1-2.157 2.686 4.48 4.48 0 0 1-3.423.375 4.47 4.47 0 0 1-2.68-2.146l-.634-1.19q.074-.482.074-.983v-2.666l6.33-3.471 2.114 3.972a4.47 4.47 0 0 1 .375 3.424z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-capsules_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCapsules;
